export default __webpack_public_path__ + "static/rain-703d4dffb9622405d9769fef0686698e.png";